import { Text, View } from "@react-pdf/renderer";
import { useMemo } from "react";

const RangeSlider = ({ value, max, rating }) => {

  const rangeValue = useMemo(() => {
    return ((value * 100) / max);
  }, [rating])

  const backgroundColor = useMemo(() => {
    switch(rating){
      case "needs_work":
        return "#e24b4b";

      case "average":
        return "#FFD93B";

      case "good":
        return "#aee658";

      case "excellent":
        return "#4dd4a4";

      default:
        return "#fff";
    }
  }, [rating]);

  return (
    <View>
      <View style={{
        width: "100%",
        height: 5,
        border: `1px solid ${backgroundColor}`,
        borderRadius: 5,
        backgroundColor
      }}></View>
      <View style={{ 
        width: 14,
        height: 14,
        border: `3px solid ${backgroundColor}`,
        borderRadius: "50%",
        marginTop: "-10px",
        backgroundColor: "#fff",
        marginLeft: `${rangeValue - 2}%`
      }}></View>
    </View>
  )
}

export default RangeSlider;